module.exports = __webpack_public_path__ + "img/fitness.f1a53bb6.svg";